


















































































import Vue from "vue";
import AlertService from "@/services/alertService";
import { Alert } from "@/models/alert";

export default Vue.extend({
  data() {
    return {
      alertList: [] as Alert[],
      displayList: [] as Alert[],
      assignedCount: "",
      closedCount: "",
      openCount: "",
      isLoaded: false,
      openClicked: true,
      assignedClicked: false,
      closedClicked: false
    };
  },

  methods: {
    setOpen(): void {
      this.displayList = this.alertList.filter(alert => alert.status.match("Open"));
      console.log("setOpen");
    },

    setClose(): void {
      this.displayList = this.alertList.filter(alert => alert.status.match("Closed"));
      console.log("setClose");
    },

    setAssigned(): void {
      this.displayList = this.alertList.filter(alert => alert.status.match("Assigned"));
      console.log("setAssigned");
    }
  },

  name: "Issues",

  async created() {
    this.isLoaded = true;
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const alertService = new AlertService(jwt);
      const response = await alertService.getAlerts();

      if (response !== undefined && response !== null) {
        if (response.data !== undefined && response.data !== null) {
          this.alertList = response.data.alerts;
          this.assignedCount = response.data.assignedCount;
          this.closedCount = response.data.closedCount;
          this.openCount = response.data.openCount;
          this.setOpen();
          this.isLoaded = false;
        }
      }
    }
  }
});
